import React from 'react'
import { ListGroup } from 'react-bootstrap'
import '@szhsin/react-menu/dist/index.css'
import PopupMenu from 'components/molecules/PopupMenu'
import { ClientDashboardItem } from 'share/domain/case'
import { MenuItemInfo } from 'components/molecules/PopupMenu'

interface CasesListViewProps {
  cases: ClientDashboardItem[] | undefined
  showPopupMenu: boolean
  popupMenuActions?: MenuItemInfo[]
}

const CasesListView = (props: CasesListViewProps): JSX.Element => {
  const renderPopUpMenu = (caseId: number) => {
    if (!props.showPopupMenu || !props.popupMenuActions) return null

    const newMenu: MenuItemInfo[] = props.popupMenuActions.map((item) => ({
      ...item,
      clickParameter: caseId
    }))

    return (
      <span className='float-right'>
        <PopupMenu menuItemList={newMenu} />
      </span>
    )
  }

  if (!props.cases) return <h3>No cases information</h3>
  return (
    <React.Fragment>
      <ListGroup>
        {props.cases?.map((matter: ClientDashboardItem, index: number) => (
          <ListGroup.Item key={index}>
            <span>
              <strong>{matter.caseType}</strong>
            </span>
            {renderPopUpMenu(matter.id)}
            <div className='fw-light'>
              Firm: {matter.firmName}
              <br />
              Status: {matter.status}
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </React.Fragment>
  )
}

export default CasesListView
